<template>
	<div class="documentation">
		<h3>{{ title }}</h3>

		<ul class="doc-unstyled-list">
			<li v-for="link in docsLinks" :key="link.title">
				<div class="clearfix">
					<div style="float: left;width: 23px;">
						<img
							:src="plugin_dir_url + 'assets/images/docs.svg'"
							style="margin-bottom: -3px;margin-right: 9px;"
						>
					</div>
					<div style="float: right;text-align: left;width: calc( 100% - 23px )">
						<a
							:href="link.href"
							style="text-decoration: none;"
						>
							{{ link.title }}
						</a>
					</div>
				</div>
			</li>
		</ul>

		<a class="view-more-button" :href="viewMore">{{ i18n.more }} →</a>
	</div>
</template>

<script>
export default {
	name: 'PostSMTPDocumentation',

	props: {
		title: {
			type: String,
			required: true,
		},
		docsLinks: {
			type: Array,
			required: true,
		},
		viewMore: {
			type: String,
			required: true,
		},
		pluginDirUrl: {
			type: String,
			required: true,
		},
		adminUrl: {
			type: String,
			required: true,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.pluginDirUrl,
		admin_url: vm.adminUrl,
    i18n: postSmtpNewDashboard.i18n.documentation,
	} ),
}
</script>

<style scoped>
.documentation {
	width: 222px;
	float: left;
	padding: 20px;
	background: #ffffff;
	margin: 0 24px 24px 0;
}

.documentation h3 {
	font-family: Poppins;
	font-size: 14px;
	font-weight: 500;
	line-height: 14px;
	text-align: left;
	color: #231F20;
}

.doc-unstyled-list {
	margin-top: 20px;
	margin-bottom: 22px;
}

.doc-unstyled-list li {
	line-height: 18px;
	margin: 10px 0;
}

.doc-unstyled-list li a {
	font-family: Poppins;
	font-size: 12px;
	font-weight: 400;
	text-align: left;
	color: #375CAF;
}

.view-more-button {
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-align: left;
	color: #375CAF;
	text-decoration: none;
}

.clearfix::after {
	content: "";
	clear: both;
	display: table;
}
</style>